import type { ProductsFeatureConfig } from '@shared/products-feature-configs';

export const products: Partial<ProductsFeatureConfig> = {
    fieldsWithGAPIPriority: ['balance', 'disposable', 'overdraft', 'nextRateAmount', 'alias'],
};
